<template>
  <div class="container" id="top">
    <van-image class="img-block" src="https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/header.webp" fit="fill" lazy-load show-loading />
    <div class="content" style="margin-top: -100px" id="form-top">
      <van-image class="img-block" src="https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/title1.webp" fit="fill" lazy-load show-loading />
      <div class="con-form">
        <van-field label="交易金额" v-model="money" type="number" @focus="focusForm" input-align="right" placeholder="请填写交易金额">
          <template #extra>
            <p style="margin-left: 5px">万元</p>
          </template>
        </van-field>
        <van-cell
          title="首付比例"
          is-link
          :value="percent ? percentName : '请选择首付比例'"
          :value-class="percent ? 'selected' : ''"
          @click="percentShow = true"
        />
        <van-cell
          title="融资期限"
          is-link
          :value="times ? timesName : '请选择融资期限'"
          :value-class="times ? 'selected' : ''"
          @click="timesShow = true"
        />
        <van-button type="primary" color="#FFD23C" class="btn-style" @click="submit">生成专属方案</van-button>
      </div>
    </div>
    <div class="content" v-if="Object.keys(financingInformation).length">
      <van-image class="img-block" src="https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/title2.webp" fit="fill" lazy-load show-loading />
      <div class="con-form">
        <div class="group">
          <div class="form-title">
            <div class="left-border"></div>
            <div class="form-title-text">融资信息</div>
          </div>
          <van-cell title="交易金额:" :value="showMoney + '万元'" />
          <van-cell title="首付比例:" :value="showPercent" />
          <van-cell title="融资期限:" :value="showTimes" />
        </div>
        <div class="group">
          <div class="form-title">
            <div class="left-border"></div>
            <div class="form-title-text">融资方案</div>
          </div>
          <van-cell title="首付金额:" :value="parseFloat(financingInformation.downPayAmount) + '万元'" />
          <van-cell title="银行保证金:" :value="parseFloat(financingInformation.bankDeposit) + '万元'" />
          <van-cell title="GPS服务费:" :value="financingInformation.gpsServiceFee + '元'" />
          <van-cell title="服务费比例:" :value="financingInformation.platformServiceFee * 100 + '%'" />
          <div class="service con-remind">*以上金额为前期总投入</div>
          <van-cell title="融资金额:" :value="parseFloat(financingInformation.financingAmount) + '万元'" />
          <van-cell title="利息总额约:" :value="parseFloat(financingInformation.grossInterest) + '万元'" />
          <van-cell title="月供金额约:" :value="parseFloat(financingInformation.monPayAmount) + '万元'" />
        </div>
        <div class="con-remind" style="margin-top: 20px">*保证金可冲抵最后一个月左右的还款（多退少补）</div>
        <div class="con-remind">*最终金融方案以实际贷款额度为准，详情咨询业务专员</div>
        <van-button type="primary" color="#ffd23c" class="btn-style" @click="toProgramme">填写贷款客户信息</van-button>
        <van-button plain type="primary" color="#852900" class="btn-style" @click="call">咨询业务专员</van-button>
      </div>
    </div>
    <div class="bottom">
      <van-image
        class="img-block"
        src="https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/question.webp"
        fit="fill"
        lazy-load
        show-loading
      />
      <van-image
        class="img-block img-bottom"
        src="https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/aboutyl.webp"
        fit="fill"
        lazy-load
        show-loading
      />
    </div>
    <van-overlay :show="overlayShow" @click="overlayShow = false">
      <div class="wrapper">
        <van-loading size="54px"><span style="font-size: 24px">测算中...</span></van-loading>
      </div>
    </van-overlay>
    <van-popup v-model="percentShow" round position="bottom">
      <van-picker
        show-toolbar
        title="首付比例"
        :columns="columnsPercent"
        value-key="text"
        @confirm="onConfirmPercent"
        @cancel="percentShow = false"
      />
    </van-popup>
    <van-popup v-model="timesShow" round position="bottom">
      <van-picker show-toolbar title="融资期限" :columns="columnsTimes" value-key="text" @confirm="onConfirmTimes" @cancel="timesShow = false" />
    </van-popup>
  </div>
</template>
<script>
export default {
  name: "business",
  components: {},
  data() {
    return {
      checkTime: "",
      submitterPhone: "",
      submitterType: "",
      submitterTime: "",
      uid: "",
      overlayShow: false,
      percentShow: false,
      timesShow: false,
      columnsPercent: [
        {
          text: "30%",
          value: 0.3
        },
        {
          text: "35%",
          value: 0.35
        },
        {
          text: "40%",
          value: 0.4
        }
      ],
      columnsTimes: [
        {
          text: "2年(24期)",
          value: 2
        },
        {
          text: "3年(36期)",
          value: 3
        }
      ],
      money: "",
      percent: "",
      percentName: "",
      times: "",
      timesName: "",
      showMoney: "",
      showPercent: "",
      showTimes: "",
      financingInformation: {}
    }
  },
  created() {
    document.title = "三一云联金服1号"
    this.checkTime = new Date().getTime().toString()
    let params = this.$route.query
    this.submitterPhone = params.phone
    this.submitterType = params.roleType
    this.uid = params.uid
  },
  methods: {
    focusForm() {
      document.getElementById("form-top").scrollIntoView(true)
    },
    onConfirmPercent(e) {
      this.percent = e.value
      this.percentName = e.text
      this.percentShow = false
    },
    onConfirmTimes(e) {
      this.times = e.value
      this.timesName = e.text
      this.timesShow = false
    },
    scrollPage() {},
    submit() {
      if (this.money == "") {
        this.$toast({ message: "请填写交易金额", position: "bottom" })
        return
      }
      if (this.money.indexOf("-") != -1) {
        this.$toast({ message: "请填写正确的交易金额", position: "bottom" })
        return
      }
      if (this.money <= 0) {
        this.$toast({ message: "交易金额需大于0", position: "bottom" })
        return
      }
      if (this.money.split(".")[1] && this.money.split(".")[1].length > 4) {
        this.$toast({ message: "交易金额最多四位小数", position: "bottom" })
        return
      }
      if (this.percent == "") {
        this.$toast({ message: "请选择首付比例", position: "bottom" })
        return
      }
      if (this.times == "") {
        this.$toast({ message: "请选择融资期限", position: "bottom" })
        return
      }
      this.submitterTime = new Date().getTime()
      const data = {
        submitTime: this.submitterTime,
        submitterPhone: this.submitterPhone,
        submitterType: this.submitterType * 1,
        uid: this.uid * 1,
        dealAmount: this.money.indexOf(".") == this.money.length - 1 ? this.money.split(".")[0] * 1 : this.money * 1,
        downPayRatio: this.percent,
        financingTerm: this.times,
        checkTime: this.checkTime
      }
      this.overlayShow = true
      this.$api.generateINfo(data).then((res) => {
        this.overlayShow = false
        if (res.data.code == 0) {
          document.getElementById("form-top").scrollIntoView(true)
          this.money = data.dealAmount
          this.showMoney = data.dealAmount
          this.showPercent = this.percentName
          this.showTimes = this.timesName
          this.financingInformation = res.data.data
        }
      })
    },
    toProgramme() {
      document.getElementById("form-top").scrollIntoView(true)
      this.$router.push({
        path: "/customer",
        query: {
          checkTime: this.checkTime,
          phone: this.submitterPhone,
          roleType: this.submitterType,
          uid: this.uid
        }
      })
      //   向app发送消息
      // if (window["_APP_ACTION_openPage"]) {
      //   window["_APP_ACTION_openPage"].postMessage('{"action":"push","webId":"finance"}');
      // }
    },
    call() {
      window.location.href = "tel:13100667773"
    }
  },
  watch: {}
}
</script>
<style lang="scss">
.container {
  .van-cell {
    background: #ffffff;
    margin-top: 0;
  }
  .van-field__label {
    color: #323233;
  }
}
</style>
<style lang="scss" scoped>
.container {
  width: 100%;
  margin: 0;
  padding: 0;
  background-color: #f8f2df;
  .van-cell__title {
    flex: 0.4;
    text-align: left;
  }

  .content {
    position: relative;
    background-color: #ffd23c;
    text-align: center;
    margin: 15px;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 10px;
    overflow: hidden;
    .con-form {
      background-color: #fff;
      padding: 10px;
      padding-bottom: 20px;
      .van-cell__value {
        color: #ccc;
        font-size: 14px;
      }
      .selected {
        color: #000;
      }
      .group {
        .van-cell__value {
          color: #000;
        }
      }
      .service {
        color: #fb463f;
        .van-cell__value {
          color: #fb463f;
        }
      }
      .con-remind {
        color: #fb463f;
        padding: 3px 15px;
        text-align: left;
      }
    }
    .form-title {
      color: #852900;
      font-weight: bold;
      text-align: left;
      font-size: 15px;
      height: 18px;
      margin: 8px 0;
      .left-border {
        width: 5px;
        height: 16px;
        float: left;
        background-color: #852900;
        border-radius: 2px;
        margin-right: 5px;
        margin-left: 5px;
      }
      .form-title-text {
        float: left;
        height: 16px;
        line-height: 17px;
      }
    }
  }
  .btn-style {
    width: 70%;
    margin-top: 20px;
    color: #852900 !important;
    font-weight: bold;
    border-radius: 24px;
    font-size: 16px;
  }
  .bottom {
    margin: 15px;
    box-sizing: border-box;
    padding-bottom: 15px;
  }
  .img-block {
    display: block;
  }
  .img-bottom {
    margin-top: 15px;
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
}
</style>
